import React, { Component } from 'react'
import { MDBContainer, MDBRow, MDBCol, MDBJumbotron,  MDBAlert,  MDBTable, MDBTableBody, MDBTableHead,  MDBBtn, MDBIcon, MDBBadge, MDBCard, MDBTypography, MDBBox } from "mdbreact";
import Axios from 'axios'
import { Layout, Menu, Breadcrumb, Icon, Select, PageHeader, Card, Avatar,  Row, Col, Popover, Button , Divider, Tooltip, Spin, Alert, message ,notification     } from 'antd';
import { StarOutlined, StarFilled, StarTwoTone, CaretDownOutlined, UserOutlined } from '@ant-design/icons';
import Modalteachingschedule from './Modalteachingschedule';
import Modalcolor from './Modalcolor';
import { QuestionCircleTwoTone } from '@ant-design/icons';
import Loadding from './Loadding';
import Getprograme from './Getprograme';
import { format } from "date-fns";
import Getteachet2 from './Getteachet2';
import Modalroom from './Modalroom';




//import { useNetworkStatus } from 'react-adaptive-hooks/network';

//import Datetime from 'react-datetime';
const { Meta } = Card;
//const { effectiveConnectionType } = useNetworkStatus();

export default class Timetable extends Component {
    
    constructor(props) {
        super(props);
        this.state = {

          thschedule:[],
          modal: false,
          term:'',
          type:'1',
          idemp:'',
          empcouncilcheck:[],
          empcouncilcheck2:[],
          empcouncilcheck3:[],
          empcouncilcheck4:[],
          day4:'', //วันสำหรับอาจารย์มีความจำเป็นที่จะไม่ว่าง
          teachingschedule:[],
          dd3:'',
          teacher:'',
          loadding:false,

        };
        this.onChange = this.onChange.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onSearch = this.onSearch.bind(this);

        this.getthschedule = this.getthschedule.bind(this);
        this.updateSearchDepartment = this.updateSearchDepartment.bind(this);
        this.getteachingschedule = this.getteachingschedule.bind(this);
        this.time = this.time.bind(this);
        this.refreshPage = this.refreshPage.bind(this);
        this.refreshteacher = this.refreshteacher.bind(this);
        this.checktime = this.checktime.bind(this);
        this.logout = this.logout.bind(this);
        this.openNotification = this.openNotification.bind(this);
      }

       logout() {
          localStorage.clear();
      
          setTimeout(() => {
            window.location.href = '/tess/'
          }, 1000);
         // this.setState({ admin_type: 'public' }
         // message.success("หมดเวลาเชื่อมต่อ..")
         notification.open({
           message: 'หมดเวลาเชื่อมต่อ',
          description:
            'กรุณาเข้าสู่ระบบใหม่อีกครั้งใหม่อีกครั้ง',
          onClick: () => {
            console.log('Notification Clicked!');
          },
        });

        }
 
        //สำหรับแจ้งเตือนหมดเวลา
       openNotification = () => {
          notification.open({
            message: 'หมดเวลาเชื่อมต่อ',
            description:
              'กรุณาเข้าสู่ระบบใหม่อีกครั้งใหม่อีกครั้ง',
            onClick: () => {
              console.log('Notification Clicked!');
            },
          });
        };

        //สำหรับเซ็คเวลาหมดอายุ
        checktime() {
          const  now = new Date();
        //  now.setMinutes(now.getMinutes() + 3); //บวกเวลาล็อกเอ้า
          const wanwela = new Date(now)
          const formattedDate = format(wanwela, "MMMM do, yyyy H:mma");
          const timeout = localStorage.getItem('timeout');
  
            if (formattedDate > timeout) {
                this.logout();
            }else{
  
            }
        }


      componentDidMount() {

        if (localStorage.getItem('name') == null) {
          
        } else {

        }

        // const token = JSON.parse(localStorage.getItem('nameuser'));
    //   this.checktime();
      }

     

    updateSearchDepartment(value) {
        // console.log(event.target.value)
        // const term = event.target.value;
        const term = value;
        this.setState({ term });
 
           setTimeout(() => {
             this.getthschedule()
           }, 500);
        //   this.checktime();
      }


      getthschedule() {
        setTimeout(() => {
           //ภายใน
            Axios.get('https://mua.kpru.ac.th/FrontEnd_Tabian/load/getthschedule/'+this.state.term)
           .then(res => {
            // console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ thschedule: res.data})
           }) 
         }, 0);
      }

      getteachingschedule() {
        this.setState({ loadding:true });
        setTimeout(() => {
           //ภายใน
            Axios.get('https://mua.kpru.ac.th/FrontEnd_Tabian/load/teachingschedule/'+this.state.term+'/'+this.state.idemp)
           .then(res => {
           //  console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ teachingschedule: res.data})
             this.setState({ loadding:false });
           //  const teacher = res.data[0].poname;
            // this.setState({ teacher });
           }) 
         }, 2000);
      }


      onChange(value) {
         // console.log(`selected ${value}`);
          const idemp = value;
          this.setState({ idemp });

          setTimeout(() => {
             Axios.get('https://mua.kpru.ac.th/FrontEnd_Tabian/load/getthcouncilcheck/1/'+this.state.term+'/'+this.state.idemp)
            .then(res => {
                    this.setState({ empcouncilcheck: res.data})
            }) 
          }, 0);

          setTimeout(() => {
             Axios.get('https://mua.kpru.ac.th/FrontEnd_Tabian/load/getthcouncilcheck/2/'+this.state.term+'/'+this.state.idemp)
            .then(res => {
                    this.setState({ empcouncilcheck2: res.data})
            }) 
          }, 0);

          setTimeout(() => {
            Axios.get('https://mua.kpru.ac.th/FrontEnd_Tabian/load/getthcouncilcheck/3/'+this.state.term+'/'+this.state.idemp)
           .then(res => {
                   this.setState({ empcouncilcheck3: res.data})
           }) 
         }, 0);

         setTimeout(() => {
          Axios.get('https://mua.kpru.ac.th/FrontEnd_Tabian/load/getthcouncilcheck/4/'+this.state.term+'/'+this.state.idemp)
         .then(res => {
                 this.setState({ empcouncilcheck4: res.data})
                 if ( res.data.length > 0) {
                      this.setState({ day4: res.data[0].day})
                 }
               }) 

           }, 0);

  

          setTimeout(() => {
            this.getteachingschedule()
          }, 500);

          }


           onBlur() {
            console.log('blur');
          }
          
           onFocus() {
            console.log('focus');
          }
          
           onSearch(val) {
            console.log('search:', val);
          }

          time() {
            const d = new Date();
            d.setMinutes(17);
            document.getElementById("demo").innerHTML = d;
          }

          refreshPage() {
            window.location.reload(false);
          }

          refreshteacher() {
           // window.location.reload(false);
           this.setState({  idemp:''})
           this.setState({ thschedule:[]})
           setTimeout(() => {
             this.getthschedule();
           }, 1000);
           
          }


          

    render() {

        const { Option } = Select;
        const dd= new Date();
        const content = (
          <div>
            <p>รายชื่อค้นหามีเฉพาะที่สอนเทอมที่เลือก</p>
          </div>
        );
      //  const teacher =  this.state.teachingschedule[0].map(teachingschedules => { {teachingschedule.poname} }  )   
     // const online = window.navigator.onLine;
      //  const teacher =  this.state.teachingschedule[0].map(teachingschedules => { {teachingschedule.poname} }  )     
      if (navigator.onLine) {
        console.log('online');
      } else {
        console.log('offline');
      }  
      // const { effectiveConnectionType } = useNetworkStatus();
    //  const  time2 = Number (1*55)
     // const  ddf = time2-5
      const  now = new Date();
      const  now2 = new Date();
  //    now.setMinutes(now.getMinutes() + 30);
      const wanwela = new Date(now)
     // const formattedDate = format(wanwela, "MMMM do, yyyy H:mma");
      const wanwela2 = new Date(now2)
     // const formattedDate2 = format(wanwela2, "MMMM do, yyyy H:mma");

     // console.log('dfdfdfd');

     // console.log(formattedDate);
     // console.log(formattedDate2);
     // console.log(totalsss);
     
    //  if (formattedDate < formattedDate2) {
    //   console.log("มาก");
    //  }else{
    //   console.log("น้อย");
    
    //  }

    //สำหรับรวมค่า
    // let sum = this.state.teachingschedule.reduce(function(prev, current) {
    //   return prev + +current.numregister
    // }, 0);
    // console.log(sum)
      
        return (
            <MDBContainer fluid>
                {/* <MDBAlert color="primary" >
                <h4><MDBIcon icon="address-book" className="indigo-text pr-3" /> จัดการตารางเรียนตารางสอน</h4>
                </MDBAlert>
                <p>{localStorage.getItem('name')}</p> */}

{/* <PageHeader
    className="site-page-header"
    onBack={() => null}
    title="จัดการตารางสอน"
    subTitle={"โดย "+localStorage.getItem('name')  }
  /> */}
   {/* <Card type="inner"  title={<h4 className="teal-text"><MDBIcon icon="atom" /> จัดการตารางเรียน</h4>} > */}
   {/* <MDBTypography blockquote bqColor='primary'>
      <MDBBox tag='p' mb={0} className='bq-title'>
        Info notification
      </MDBBox>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Maiores
        quibusdam dignissimos itaque harum illo! Quidem, corporis at quae
        tempore nisi impedit cupiditate perferendis nesciunt, ex dolores
        doloremque! Sit, rem, in?
      </p>
    </MDBTypography> */}
   <Card type="inner"  title={<h4 className="unique-text"><MDBIcon icon="book" />  จัดการตารางเรียน ทั้งหมด </h4>} >


   


   <Row>
      <Col flex="1 1 200px"></Col>
      <Col flex="0 1 200px">
        <Meta
      avatar={<Avatar  src="https://i.gifer.com/g2uA.gif" />}
      title={localStorage.getItem('name')}
      description="ผู้ดูแลระบบ"
      
    />
      </Col>
    </Row>
   
   {/* <p>โดย {localStorage.getItem('name')} [ผู้ดูแลระบบ]</p> */}           
            <br/>
            <MDBRow>

            <MDBCol sm="4">
                <div>
                    <CaretDownOutlined style={{ fontSize: '30px', color: '#0d47a1' }}  />   
                    
                        <Select
                            showSearch
                            style={{ width: 300 }}
                            placeholder="เลือกเทอม"
                            optionFilterProp="children"
                            onChange={this.updateSearchDepartment}
                            onFocus={this.onFocus}
                            onBlur={this.onBlur}
                            onSearch={this.onSearch}
                            filterOption={(input, option) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                         >
                            {/* <Option value="3/2563">3/2563</Option>
                            <Option value="1/2564">1/2564</Option>
                            <Option value="2/2564">2/2564</Option>
                            <Option value="3/2564">3/2564</Option> */}
                            <Option value="1/2565">1/2565</Option>
                            <Option value="2/2565">2/2565</Option>
                            <Option value="3/2565">3/2565</Option>
                            <Option value="1/2566">1/2566</Option>
                            <Option ative value="2/2566">2/2566</Option>
                            <Option ative value="3/2566">3/2566</Option>
                            <Option value="1/2567">1/2567</Option>
                            <Option ative value="2/2567">2/2567</Option>
                            <Option ative value="3/2567">3/2567</Option>
                            <Option value="1/2568">1/2568</Option>
                            <Option value="2/2568">2/2568</Option>
                            <Option value="3/2568">3/2568</Option>
                           
                        </Select>
                    </div>
                    {/* <br/> */}
            </MDBCol>

            <MDBCol sm="4">
        { this.state.term === "" ?<> </>:<> 
                    <> 
                    <UserOutlined style={{ fontSize: '30px', color: '#0d47a1' }}  />   

                        <Select
                            showSearch
                            style={{ width: 300 }}
                            placeholder="เลือกอาจารย์"
                            optionFilterProp="children"
                            onChange={this.onChange}
                            onFocus={this.onFocus}
                            onBlur={this.onBlur}
                            onSearch={this.onSearch}
                            filterOption={(input, option) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                        >
                            {/* <Option value="jack">Jack</Option>
                            <Option value="lucy">Lucy</Option>
                            <Option value="tom">Tom</Option> */}
                        {this.state.thschedule.map((emp,index )  => 
                        <option value={emp.teacher_id1}>{emp.prenm+ emp.poname}</option>
                        )}
                        </Select>

                          
                        <br/>
                    </>
                    </> }

            </MDBCol>
            <MDBCol className="text-right" sm="4">  

                   <MDBIcon icon="retweet" size="lg" onClick={this.refreshteacher} />

               <Divider type="vertical" />
                <Popover content={content} title="หมายเหตุ" trigger="hover">
                               {/* <QuestionCircleTwoTone /> */} <MDBIcon far icon="comment-dots" size="lg" />
                </Popover>
                <Divider type="vertical" />
                        <Tooltip title="refresh">
                           <MDBIcon icon="redo-alt" size="lg" onClick={this.refreshPage} />
                        </Tooltip>
            </MDBCol>
       </MDBRow>


                { this.state.empcouncilcheck.length === 0 ? <> </> : 
                <>
                <br/>
                <MDBCard>
                <MDBAlert color="danger">
                    <a href="#!" className="alert-link"> ! อาจารย์มีรายชื่อในการประชุมกรรมสภามหาวิทยาลัย</a> ทุกวันพฤหัสบดี ของทุกเดือน
                </MDBAlert>
                </MDBCard>
                </>}


                { this.state.empcouncilcheck2.length === 0 ? <> </> : 
                <>
                <br/>
                <MDBCard>
                <MDBAlert color="danger ">
                    <a href="#!" className="alert-link"> ! อาจารย์มีรายชื่อในการประชุมกรรมการบริหารมหาวิทยาลัย</a> ทุกวันอังคาร ของทุกเดือน
                </MDBAlert>
                </MDBCard>
                </>}

                { this.state.empcouncilcheck3.length === 0 ? <> </> : 
                <>
                <br/>
                <MDBCard>
                <MDBAlert color="danger ">
                    <a href="#!" className="alert-link"> ! อาจารย์มีรายชื่อในการประชุมกรรมการสภาวิชาการ</a> ทุกวันพฤหัสบดี ของทุกเดือน
                </MDBAlert>
                </MDBCard>
                </>}


                { this.state.empcouncilcheck4.length === 0 ? <> </> : 
                <>
                <br/>
                <MDBCard>
                <MDBAlert color="danger">
                    <a href="#!" className="alert-link"> ! อาจารย์มีรายชื่อในการแจ้งติดภารกิจ</a> ทุกวัน {this.state.day4} ของทุกเดือน
                </MDBAlert>
                </MDBCard>
                </>}


                {/* <p>{this.state.idemp}</p> */}
                {/* <p>{this.state.empcouncilcheck}</p> */}


          { this.state.term === '' ? <></> :<> 
          <br/>
          {/* <hr/> */}
          <Divider><h5 className="text-center">ตารางสอนอาจารย์</h5> </Divider> 
           <h5 className="text-center"> ภาคเรียนที่ {this.state.term}</h5> 
           {this.state.teacher === ''?<></>:<>  <h5 className="text-center">อาจารย์{this.state.teacher} </h5> </> }

           {this.state.loadding === true ?<><p className="text-center">   
             <Spin >
                <Alert
                  message="กำลังโหลดข้อมูล"
                  description="กำลังโหลดข้อมูลตารางสอนกรุณารอสักครู่"
                  type="info"
                />
              </Spin></p> </>:<>
              
              </>}
              
              
          
           {/* {this.state.loadding === true ?<> <p className="text-center"> xx<Spin size="large" /></p> </>:<></>} */}
          {this.state.empcouncil === ''  ? <>
          <p className="text-center"> <Spin size="large" /></p> 
            </>: <>
            <MDBTable bordered small responsive>
                <MDBTableHead color="grey lighten-1" >
                <tr>
                    <th rowspan="2" className="text-center">ลำดับ</th>
                   
                    <th rowspan="2" className="text-center">รหัสวิชา</th>
                    <th rowspan="2" className="text-center">ชื่อวิชา</th>
                    <th rowspan="2" className="text-center">หน่วยกิต</th>
                    <th rowspan="2" className="text-center">หมู่เรียน</th>
                    <th rowspan="2" className="text-center">สาขา</th>
                    <th rowspan="2" className="text-center">จำนวน</th>
                    <th rowspan="2" className="text-center">กลุ่ม</th>
                    {/* <th rowspan="2" className="text-center">ผู้สอน</th> */}
                    <th  colspan="3" className="text-center">ช่วงที่ 1 </th>
                    <th  colspan="3" className="text-center">ช่วงที่ 2 </th>
                    <th  colspan="3" className="text-center">ช่วงที่ 3 </th>
                    {/* <th>วัน</th>
                    <th>เวลา</th>
                    <th>ห้องเรียน</th> */}
                    <th rowspan="2"  className="text-center">จัดการ</th>
                  </tr>
                  <tr>
                   
                    {/* <th  colspan="3">วัน</th> */}
                    <th className="text-center">วัน</th>
                    <th className="text-center">เวลา</th>
                    <th className="text-center">ห้องเรียน</th>

                    <th className="text-center">วัน</th>
                    <th className="text-center">เวลา</th>
                    <th className="text-center">ห้องเรียน</th>

                    <th className="text-center">วัน</th>
                    <th className="text-center">เวลา</th>
                    <th className="text-center">ห้องเรียน</th>
                    
                    </tr>
                </MDBTableHead>

                  {/* {this.state.loadding === true ?<> <p className="text-center"> xx<Spin size="large" /></p> </>:<></>} */}
                 
                   
                <MDBTableBody>
                {this.state.teachingschedule.map((teachingschedule,index) => {
                
                   //กศบป
                    const  time2 = Number (teachingschedule.hour1*55)
                    const  ddf = time2-5
                    const  now = new Date("December 25, 1995 "+teachingschedule.times1+" ");
                    const totalsss = now.setMinutes(now.getMinutes()+ddf);
                    const wanwela = new Date(totalsss)
                   // const hourssa = ((wanwela + 11) % 12 + 1) 
                    var options = { hour12: false };
                    const wanwela1 =  wanwela.toLocaleTimeString('en-US', options)

                    //ปกติ
                    const  timenormal = Number (teachingschedule.hour1*60)
                    const  now2 = new Date("December 25, 1995 "+teachingschedule.times1+" ");
                    const totalsss2 = now2.setMinutes(now2.getMinutes()+timenormal);
                    const wanwela2 = new Date(totalsss2);
                    const normal =  wanwela2.toLocaleTimeString()
        
                     return   <tr>
                          <td className="text-center">{index+1}</td>
                          <td>{teachingschedule.SUBJCODE}</td>
                          <td><p className="font-weight-bold teal-text">{teachingschedule.SUBJNAME}</p>
                          {teachingschedule.prenm}{teachingschedule.poname}
                          {teachingschedule.teacher_id2 != null ?<><Getteachet2 teacher_id2={teachingschedule.teacher_id2}  /></>:<></>}
                          {teachingschedule.teacher_id3 != null ?<><Getteachet2 teacher_id2={teachingschedule.teacher_id3}  /></>:<></>}
                          {teachingschedule.teacher_id4 != null ?<><Getteachet2 teacher_id2={teachingschedule.teacher_id4}  /></>:<></>}
                          {teachingschedule.teacher_id5 != null ?<><Getteachet2 teacher_id2={teachingschedule.teacher_id5}  /></>:<></>}
                          {teachingschedule.teacher_id6 != null ?<><Getteachet2 teacher_id2={teachingschedule.teacher_id6}  /></>:<></>}
                          {teachingschedule.teacher_id7 != null ?<><Getteachet2 teacher_id2={teachingschedule.teacher_id7}  /></>:<></>}
                          {teachingschedule.teacher_id8 != null ?<><Getteachet2 teacher_id2={teachingschedule.teacher_id8}  /></>:<></>}
                          {teachingschedule.teacher_id9 != null ?<><Getteachet2 teacher_id2={teachingschedule.teacher_id9}  /></>:<></>}
                          {teachingschedule.teacher_id10 != null ?<><Getteachet2 teacher_id2={teachingschedule.teacher_id10}  /></>:<></>}
                          </td>
                          <td>{teachingschedule.CRHR}</td>
                          { teachingschedule.id_major.substring(2, 3) === '2' ?<>
                          <td className='bg-warning'>{teachingschedule.id_major}</td>
                          </>:<>
                          <td >{teachingschedule.id_major}</td>
                          </>}
                           <td>{teachingschedule.t_mjname }</td>
                          {/* <td>{teachingschedule.t_mjname === ''?<>{teachingschedule.t_mjname}</>:<><Getprograme id_major = {teachingschedule.id_major}/></>}</td> */}
                          <td className="text-center">{teachingschedule.numregister}</td>
                          <td> <p><Modalcolor idcolor={teachingschedule.group_id} /></p></td>
                          {/* <td>อาจารย์{teachingschedule.poname}</td> */}

                    {/* ช่วงที่1 */}
                          <td> {teachingschedule.weekly1 === '1' ?<> จันทร์</>:<></> }
                               {teachingschedule.weekly1 === '2' ?<> อังคาร</>:<></> }
                               {teachingschedule.weekly1 === '3' ?<> พุธ</>:<></> }
                               {teachingschedule.weekly1 === '4' ?<> พฤหัสบดี</>:<></> }
                               {teachingschedule.weekly1 === '5' ?<> ศุกร์</>:<></> }
                               {teachingschedule.weekly1 === '6' ?<> เสาร์</>:<></> }
                               {teachingschedule.weekly1 === '7' ?<> อาทิตย์</>:<></> }
                               {teachingschedule.weekly1 === '8' ?<> ----</>:<></> }
                                {teachingschedule.weekly1 === '9' ?<> MOOC</>:<></> }
                          </td>
                          <td>
                              {teachingschedule.times1 === null || teachingschedule.times1 === ''  ? <></> :<>
                              {teachingschedule.weekly1 === '8' ?<> ----</>:<>
                                  {teachingschedule.weekly1 === '9' ?<>MOOC</>:<>
                                  {teachingschedule.times1} -
                                                                {teachingschedule.timesend1}
                                  </>}
                              

                              </> }
                              
                             
                                </> }
                          </td>
                          <td >
                          {teachingschedule.weekly1 === '8' ?<> ----</>:<> 

                               {teachingschedule.times1 === null || teachingschedule.times1 === '' || teachingschedule.classroom1.substring(0, 2) !=='99' ?<>
                                  {teachingschedule.classroom1}
                                </>:<>
                                    <Modalroom idroom={teachingschedule.classroom1} />
                                  </>}
                               
                          </> }
                          {/* {teachingschedule.classroom1} */}
                           </td>

                    {/* ช่วงที่2 */}
                          <td > {teachingschedule.weekly2 === '1' ?<> จันทร์</>:<></> }
                                {teachingschedule.weekly2 === '2' ?<> อังคาร</>:<></> }
                                {teachingschedule.weekly2 === '3' ?<> พุธ</>:<></> }
                                {teachingschedule.weekly2 === '4' ?<> พฤหัสบดี</>:<></> }
                                {teachingschedule.weekly2 === '5' ?<> ศุกร์</>:<></> }
                                {teachingschedule.weekly2 === '6' ?<> เสาร์</>:<></> }
                                {teachingschedule.weekly2 === '7' ?<> อาทิตย์</>:<></> }
                                {teachingschedule.weekly2 === '8' ?<> ----</>:<></> }
                                {teachingschedule.weekly2 === '9' ?<> MOOC</>:<></> }
                          </td>
                          <td>
                              {teachingschedule.times2 === null || teachingschedule.times2 === '' ? <></> :<>
                              {teachingschedule.weekly1 === '8' ?<> ----</>:<>  

                                                      {teachingschedule.weekly1 === '9' ?<>MOOC</>:<>
                        {teachingschedule.times2} -
                                                      {teachingschedule.timesend2}</> }
                        </>}
                             
                             
                             
                                </> }
                          </td>
                          <td>{teachingschedule.classroom2}</td>

                    {/* ช่วงที่3 */}
                          <td > {teachingschedule.weekly3 === '1' ?<> จันทร์</>:<></> }
                                {teachingschedule.weekly3 === '2' ?<> อังคาร</>:<></> }
                                {teachingschedule.weekly3 === '3' ?<> พุธ</>:<></> }
                                {teachingschedule.weekly3 === '4' ?<> พฤหัสบดี</>:<></> }
                                {teachingschedule.weekly3 === '5' ?<> ศุกร์</>:<></> }
                                {teachingschedule.weekly3 === '6' ?<> เสาร์</>:<></> }
                                {teachingschedule.weekly3 === '7' ?<> อาทิตย์</>:<></> }
                                {teachingschedule.weekly3 === '8' ?<> ----</>:<></> }
                                {teachingschedule.weekly3 === '9' ?<> MOOC</>:<></> }
                          </td>
                          <td>
                              {teachingschedule.times3 === null || teachingschedule.times3 === '' ? <></> :<> 
                              {teachingschedule.weekly1 === '8' ?<> ----</>:<> 
                                                      {teachingschedule.weekly1 === '9' ?<>MOOC</>:<>
 {teachingschedule.times3} -
                              {teachingschedule.timesend3}
</>}
                              </> }
                            
                            
                               </> }
                          </td>
                          <td>{teachingschedule.classroom3}</td>
                          <td>

                            {teachingschedule.CRHR === null ?<>
                            </>:<>
                             <Modalteachingschedule  SUBJCODE={teachingschedule.SUBJCODE} SUBJNAME={teachingschedule.SUBJNAME} 
                               CRHR={teachingschedule.CRHR} Ch_check1={teachingschedule.CRHR.substring(3, 2)} Ch_checka1={teachingschedule.CRHR.substring(5, 4)}  id_major={teachingschedule.id_major}  major={teachingschedule.major}  poname={teachingschedule.poname}  numregister={teachingschedule.numregister} 
                               teacher_id={teachingschedule.teacher_id1} 
                               teacher_id2={teachingschedule.teacher_id2} 
                               teacher_id3={teachingschedule.teacher_id3} 
                               teacher_id4={teachingschedule.teacher_id4} 
                               teacher_id5={teachingschedule.teacher_id5} 
                               teacher_id6={teachingschedule.teacher_id6} 
                               teacher_id7={teachingschedule.teacher_id7} 
                               teacher_id8={teachingschedule.teacher_id8} 
                               teacher_id9={teachingschedule.teacher_id9} 
                               teacher_id10={teachingschedule.teacher_id10} 
                                term={this.state.term} getteachingschedule={this.getteachingschedule} group_id={teachingschedule.group_id} stu_type={teachingschedule.stu_type}  />
                            </>}
                             
                          </td>
                          </tr>
                  
                })}   
                </MDBTableBody>
               


            </MDBTable>
            <MDBBtn color="warning" size='sm'></MDBBtn> หมายถึง นักศึกษาประเภท กศ.บป
            </> }

           
       

            
            {/* {this.state.loadding === true ?<><p className="text-center">   
             <Spin >
                <Alert
                  message="กำลังโหลดข้อมูล"
                  description="กำลังโหลดข้อมูลตารางสอนกรุณารอสักครู่"
                  type="info"
                />
              </Spin></p> </>:<></>} */}



            {/* <p className="text-center">    <Spin tip="Loading...">
              <Alert
                message="Alert message title"
                description="Further details about the context of this alert."
                type="info"
              />
              </Spin></p> */}
            {/* <p>หมายเหตุ : ข้อมูลใช้ประกอบการจัดตารางสอน ไม่ให้ชนกับการประชุม</p> */}
          
        </>}
      
        </Card>
         
            </MDBContainer>
            
        )
    }
}
